import { useCustomWebkitScrollbar } from './useCustomWebkitScrollbar.js';
export { useIsMounted } from './useIsMounted.js';

var hooks = {
    useCustomWebkitScrollbar: useCustomWebkitScrollbar,
};

export { hooks };
